import * as React from 'react';
import type { FirstPrincipleQuestion } from '../types';
import {
  ReviewRoot,
  ReviewHeader,
  ReviewTitle,
  ReviewSubtitle,
  ReviewCard,
  ReviewRow,
  ReviewRowHeader,
  QuestionNumber,
  StateTag,
  StateTagText,
  ResponsePreview,
  AddResponseRow,
  AddResponseLink,
  ReviewDivider,
  ReviewSpacer,
  SubmitWrap,
  SubmitBtn,
} from './review.styled';

type Props = {
  questions: FirstPrincipleQuestion[];
  answers: Record<string, string>;
  submitting: boolean;
  onGoToQuestion: (index: number) => void;
  onSubmit: () => void;
};

export const FpReview: React.FC<Props> = ({
  questions,
  answers,
  submitting,
  onGoToQuestion,
  onSubmit,
}) => {
  const total = questions.length;

  return (
    <ReviewRoot>
      <ReviewHeader>
        <ReviewTitle>Reflection overview</ReviewTitle>
        <ReviewSubtitle>You can revisit any response before submitting.</ReviewSubtitle>
      </ReviewHeader>

      <ReviewCard>
        {questions.map((q, idx) => {
          const answerText = (answers[q.id] ?? '').trim();
          const isAnswered = answerText.length > 0;

          return (
            <React.Fragment key={q.id}>
              {idx > 0 && <ReviewDivider />}
              <ReviewRow $unanswered={!isAnswered}>
                <ReviewRowHeader>
                  <QuestionNumber>
                    {idx + 1}/{total}
                  </QuestionNumber>
                  <StateTag $unanswered={!isAnswered}>
                    <StateTagText>{isAnswered ? 'Answered' : 'Unanswered'}</StateTagText>
                  </StateTag>
                </ReviewRowHeader>

                <ResponsePreview>
                  {isAnswered ? answerText : 'No response yet'}
                </ResponsePreview>

                {!isAnswered && (
                  <AddResponseRow>
                    <AddResponseLink type="button" onClick={() => onGoToQuestion(idx)}>
                      Add response
                    </AddResponseLink>
                  </AddResponseRow>
                )}
              </ReviewRow>
            </React.Fragment>
          );
        })}
      </ReviewCard>

      <ReviewSpacer />

      <SubmitWrap>
        <SubmitBtn type="button" onClick={onSubmit} disabled={submitting}>
          {submitting ? 'Submitting\u2026' : 'Submit reflections'}
        </SubmitBtn>
      </SubmitWrap>
    </ReviewRoot>
  );
};
